import React, { useState } from 'react'
import { Form } from 'react-bootstrap'
import { InboxOutlined, MinusCircleOutlined } from '@ant-design/icons'
import { Upload } from "antd"

import { handleError } from '../../../helpers'

const { Dragger } = Upload

export default function DocumentForm({ 
    apiService, onSuccess, defaultTitle = '', defaultKeywords = '', isUpdate = false
}) {
    const [title, setTitle] = useState(defaultTitle)
    const [keywords, setKeywords] = useState(defaultKeywords)

    const props = {
        multiple: false,
        customRequest: async ({ file, onError, onSuccess: handleSuccess }) => {
            const fileExt = file.name.split('.').pop().toLowerCase()

            const values = new FormData()
            values.append('file', file)
            values.append('file_path', `app/documents/${new Date().getTime()}.${fileExt}`)
            values.append('title', title)
            values.append('keywords', keywords)

            if (isUpdate) { values.append('_method', 'PUT') }

            try {
                const response = await apiService(values)
                handleSuccess(response.data, file)
                onSuccess()
            } catch (error) {
                onError(error)
                handleError(error)
                console.error('Error al subir el archivo: ', error.message)
            }
        }
    };

    return (
        <>
            <Form.Group>
                <Form.Label>Nombre del Documento <span className='text-danger'>*</span></Form.Label>
                <Form.Control 
                    value={title}
                    onChange={e => setTitle(e.target.value)}
                    className="full-width"
                    placeholder='Escriba aquí el nombre del documento...'
                />
            </Form.Group>
            <Form.Group>
                <Form.Label>Palabras Clave (para búsqueda)<small>(opcional)</small></Form.Label>
                <Form.Control 
                    as="textarea" 
                    value={keywords} 
                    onChange={e => setKeywords(e.target.value)} 
                    style={{ height: '80px' }} 
                    placeholder='Escriba aquí las palabras clave...'
                />
                <Form.Text className="text-muted">
                    Las palabras clave se separan por comas.
                </Form.Text>
            </Form.Group>
            <Dragger {...props} disabled={!title}>
                <p className="ant-upload-drag-icon">
                    { title ? <InboxOutlined /> : <MinusCircleOutlined style={{ color:'#888' }} />}
                </p>
                <p className="ant-upload-text">
                    { title ? 'Haga clic o arrastre el adjunto' : 'Ingrese el Nombre del Documento Primero' }
                </p>
                <p className="ant-upload-hint">
                    Solo se permite adjuntar archivos menores a 5MB.
                </p>
            </Dragger>
        </>
    )
}
